import 'simplebar-react/dist/simplebar.min.css';

import { Navigate, Route, BrowserRouter, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
// @mui
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// google
import { GoogleOAuthProvider } from '@react-oauth/google';
// theme
import SnackbarProvider from './components/snackbar';
import { store, persistor } from './redux/store';
import { AuthProvider } from './auth/JwtContext';
import { useAuthContext } from './auth/useAuthContext';
import ThemeProvider from './theme';
import { ThemeSettings, SettingsProvider } from './components/settings';

import Home from './layouts/dashboard';
import PageNotFound from "./components/PageNotFound/PageNotFound";
import AuthGuard from './auth/AuthGuard';
import Login from "./pages/auth/LoginCoverPage";
import Register from "./pages/auth/RegisterCoverPage";
import ResetPassword from "./pages/auth/ResetPasswordPage";
import Account from "./pages/account/AccountPersonalPage";
import Form from './pages/form/FormPage';
import UserListPage from './pages/admin/UserListPage';
import HistoryListPage from './pages/account/HistoryListPage';

// ----------------------------------------------------------------------

function AppRoutes() {
  const { user } = useAuthContext();

  return (
    <Routes>
      <Route path='/' element={<AuthGuard><Home /></AuthGuard>}>
        <Route index element={<Navigate to={user && user?.UserTypeID !== 1 ? '/form' : '/userListPage'} replace />} />

        <Route path='/form' element={<Form />} />
        <Route path="/account" element={<Account />} />
        <Route path="/userListPage" element={<UserListPage />} />
        <Route path="/historyListPage" element={<HistoryListPage />} />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/resetPassword" element={<ResetPassword />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <GoogleOAuthProvider clientId="100787885409-gncp652c724iviban0r1sm7kb22sgm9g.apps.googleusercontent.com">
        <Provider store={store}>
          <HelmetProvider>
            <PersistGate loading={null} persistor={persistor}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SettingsProvider>
                  <BrowserRouter basename="/CMS">
                    <ThemeProvider>
                      <ThemeSettings>
                        <SnackbarProvider>
                          <AppRoutes />
                        </SnackbarProvider>
                      </ThemeSettings>
                    </ThemeProvider>
                  </BrowserRouter>
                </SettingsProvider>
              </LocalizationProvider>
            </PersistGate>
          </HelmetProvider>
        </Provider>
      </GoogleOAuthProvider>
    </AuthProvider>
  );
}
